// =============================================================================
// Category sidebar — accordion (single-open) + mobile off-canvas drawer.
// Below lg the toggle button slides the drawer in, locks body scroll, traps
// focus, and dismisses on ESC / backdrop / close button. Above lg the drawer
// markup renders inline and the toggle is hidden by CSS.
// =============================================================================
(function ($) {
    'use strict';

    $(function () {
        const $sidebar = $('[data-category-sidebar]');
        if (!$sidebar.length) { return; }

        const $accordions = $sidebar.find('[data-category-accordion]');
        const $sidebarToggle = $sidebar.find('[data-category-sidebar-toggle]');
        const $sidebarClose = $sidebar.find('[data-category-sidebar-close]');
        const $sidebarBackdrop = $sidebar.find('[data-category-sidebar-backdrop]');
        const $drawer = $sidebar.find('.category-sidebar__drawer');
        const $body = $('body');

        let lastFocusedBeforeOpen = null;

        // Single-open accordion
        $sidebar.on('click', '[data-category-accordion-toggle]', function (e) {
            e.preventDefault();
            const $btn = $(this);
            const $item = $btn.closest('[data-category-accordion]');
            const wasOpen = $item.hasClass('is-open');

            $accordions.removeClass('is-open')
                .find('[data-category-accordion-toggle]').attr('aria-expanded', 'false');

            if (!wasOpen) {
                $item.addClass('is-open');
                $btn.attr('aria-expanded', 'true');
            }
        });

        function openDrawer() {
            if ($sidebar.hasClass('is-open')) { return; }

            lastFocusedBeforeOpen = document.activeElement;

            $body.addClass('is-category-drawer-open');
            $sidebarBackdrop.removeAttr('hidden');
            $sidebar.addClass('is-open');
            $sidebarToggle.attr('aria-expanded', 'true');
            $drawer.attr('aria-hidden', 'false');

            // Defer focus so the focus ring lands after the slide animation.
            setTimeout(() => { $drawer.trigger('focus'); }, 50);
        }

        function closeDrawer() {
            if (!$sidebar.hasClass('is-open')) { return; }

            $sidebar.removeClass('is-open');
            $sidebarToggle.attr('aria-expanded', 'false');
            $drawer.attr('aria-hidden', 'true');
            $body.removeClass('is-category-drawer-open');

            // Hide backdrop after its fade-out completes.
            setTimeout(() => {
                if (!$sidebar.hasClass('is-open')) {
                    $sidebarBackdrop.attr('hidden', 'hidden');
                }
            }, 320);

            if (lastFocusedBeforeOpen) {
                try { lastFocusedBeforeOpen.focus(); } catch (_) { /* element may be gone */ }
            }
        }

        $sidebarToggle.on('click', () => {
            if ($sidebar.hasClass('is-open')) { closeDrawer(); }
            else { openDrawer(); }
        });

        $sidebarClose.on('click', closeDrawer);
        $sidebarBackdrop.on('click', closeDrawer);

        $(document).on('keydown', (e) => {
            if (e.key === 'Escape' && $sidebar.hasClass('is-open')) {
                closeDrawer();
            }
        });

        // Close the drawer if the viewport widens past lg while it's open —
        // otherwise the inline desktop layout inherits fixed-positioning state.
        let resizeTimer;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => {
                if (window.innerWidth >= 992 && $sidebar.hasClass('is-open')) {
                    closeDrawer();
                }
            }, 100);
        });
    });
})(jQuery);
